module.exports = __webpack_public_path__ + "staticfr/media/marcas (6).659cc3f3.jpg";